import React, { useEffect, useState } from 'react'
import PageHeader from '../../view/pageheader'
import TableComponent from '../CustomComponents/TableComponent'
import { Button, Card, DatePicker, Form, Input, Modal, Select, Space } from 'antd'
import { SearchOutlined, ArrowRightOutlined, RedoOutlined } from '@ant-design/icons'
import SearchComponent from '../CustomComponents/SearchComponent'
import dayjs from 'dayjs'
import { getEventBoxes } from '../../store/reducer/jobSlice'
import { getEventList } from '../../store/reducer/eventSlice';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom'

const EventBoxes = () => {
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getEventBoxesData } = useSelector((state) => state.jobs);
    const { eventListData, } = useSelector((state) => state.events);
    const [searchModal, setSearchModal] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [searchDate, setSearchDate] = useState(null);
    const [clearFilter, setClearFilter] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const { count: totalCount, data: tableData } = getEventBoxesData || {};
    const role_id = localStorage.getItem('role_id')
    const [searchForm] = Form.useForm();
    const columns = [
        {
            title: 'Barcode',
            dataIndex: 'barcode',
            key: 'barcode',
            align: 'center',
        },
        {
            title: 'Spec ID',
            dataIndex: 'spec_id',
            key: 'spec_id',
            align: 'center',
        },
        {
            title: 'Spec Box No',
            dataIndex: 'spec_box_number',
            key: 'spec_box_number',
            align: 'center',

        },

        {
            title: 'Stage',
            dataIndex: 'event_stage',
            key: 'event_stage',
            align: 'center',
            render: data => {
                if (data) {
                    return <span>{data}</span>
                } else {
                    return <span> Warehouse</span>
                }

            },
        },
        {
            title: 'Box Status',
            dataIndex: 'box_status',
            key: 'box_status',
            align: 'center',
            render: (_, record) => (
                <span
                    style={record.is_moved == 1 ? { color: 'red', fontWeight: 600 } : {}}
                >
                    {record.is_moved == 1
                        ? record?.box_status
                            ? `${record.box_status} `
                            : ''
                        : record?.box_status || ''}
                </span>


            ),

        },
        {
            title: 'Pickup Date',
            dataIndex: 'pickup_date',
            key: 'pickup_date',
            align: 'center',
            render: (data) => {
                return data ? dayjs(data).format('MM/DD/YYYY') : 'Yet to update'; // Format date to MM/DD/YYYY
            }
        },
        {
            title: 'Box State',
            key: 'box_state',
            render: (_, record) => (
                <span
                    style={record.is_moved == 1 ? { color: 'red', fontWeight: 600 } : {}}
                >
                    {record.is_moved == 1
                        ? record?.box_state
                            ? `${record.box_state} - ${record.moved_spec || ''}`
                            : ''
                        : record?.box_state || ''}
                </span>


            ),
            align: 'center',
        },
        {
            title: 'Process Box',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    {/* <Button className="primary-btn rounded-4">View</Button> */}
                    <Button
                        onClick={() => {
                            navigate(`/jobs/job_event/${window.btoa(record.job_spec_id)}`, {
                                state: {
                                    job_name: window.btoa(record.job_name),
                                    spec_id: record?.spec_id,
                                    job_barcode: record?.barcode,
                                    // workflow_name: workflow_name,
                                    customer_id: window.btoa(record?.user_id),
                                    // workflow_id: workflow_id

                                }
                            })
                        }}
                        icon={<ArrowRightOutlined />} className="primary-btn rounded-1"></Button>
                </Space>
            ),
        }
    ]
    function getData(payload = {}) {
        const params = { ...payload };

        // Removed stage condition here as it was handled within handleSearch previously
        // The logic for filtering by stage/status should come directly from the payload/form.
        const box_status = params.box_status
        const pickup_date = params.pickup_date

        dispatch(getEventList({ query: "" })); // Fetch event list data
        dispatch(getEventBoxes({
            event_id: window.atob(id),
            ...payload,
            ...(pickup_date ? { pickup_date } : {}),
            ...(box_status ? { box_status } : {})
        }));
    }
    useEffect(() => {
        // Fetch initial data when component mounts
        getData();
    }, []);
    const eventData = eventListData?.data?.map((item) => ({
        value: item.id,
        label: item.eventname,
    }))
    const boxStatus = [
        {
            label: 'New',
            value: 'New'
        },
        {
            label: 'InComplete',
            value: 'InComplete'
        },
        {
            label: 'Completed',
            value: 'Completed'
        },
        {
            label: 'Dispositon Completed',
            value: 'Dispositon Completed'
        },
        {
            label: 'Re Assign Spec',
            value: 'Re Assign Spec'
        }

    ]
    const handleSearchClick = () => {
        if (!searchValue.trim()) {
            // reset if empty
            getData({ query: "" });
            return;
        }

        // Find the record in your tableData that matches the entered Box Number
        const record = tableData?.find(
            (item) => String(item.barcode).toLowerCase() === searchValue.toLowerCase()
        );
        if (record) {
            // Navigate exactly like Process Box button
            navigate(`/jobs/job_event/${window.btoa(record.job_spec_id)}`, {
                state: {
                    job_name: window.btoa(record.job_name),
                    spec_id: record?.spec_id,
                    job_barcode: record?.barcode,
                    customer_id: window.btoa(record?.user_id),
                }
            });
        } else {
            // If not found, fallback to search API
            getData({ query: searchValue });
        }
    };

    const handleCancel = () => {
        searchForm.resetFields();
        setSearchModal(false);
    };
    const handleSearch = (values) => {
        const payloadData = {
            query: values.searchText || '',
        };

        // Add pickup_date only if selected, formatting with dayjs
        if (values.searchDate) {
            payloadData.pickup_date = values.searchDate.format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }

        if (values.boxStatusValue) {
            payloadData.box_status = values.boxStatusValue;
        }

        if (values.stage) {
            payloadData.stage = values.stage
        }

        setClearFilter(true);
        getData(payloadData);
        setSearchModal(false)

        // The form fields are reset automatically on close if we call form.resetFields() in handleCancel
    };
    const handleClearAllFilters = () => {
        setClearFilter(false);
        searchForm.resetFields(); // Reset the modal form state
        // You may need to call getData to clear filters visually on the main table
        // Ensure that any other external filter states (if they existed) are cleared here
        getData({});
    }
    return (
        <>
            <PageHeader HeaderText="Event Boxes" Breadcrumb={[{ name: "Event Boxes" }]} backgroundUrlName={true} />
            <Card style={{ marginTop: "-28px", }}
                // title="All Boxes"
                extra={
                    <>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                margin: "10px 0"
                            }}
                        >
                            {/* Left side: Search Box Number */}
                            <div style={{ display: "flex", alignItems: "left", marginRight: role_id == 3 ? '250px' : '350px', gap: "10px" }}>
                                <SearchComponent
                                    onChange={e => {
                                        const val = e.target.value;
                                        setSearchValue(val);

                                        if (!val.trim()) {
                                            getData({});
                                        }
                                    }}
                                    onPressEnter={handleSearchClick}
                                    style={{ width: "300px" }}
                                    placeHolder="Search Box Number"
                                />
                                <Button className="primary-btn rounded-4" onClick={handleSearchClick}>
                                    Search Box Number
                                </Button>
                            </div>

                            {/* Right side: Search Filter */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                                {clearFilter &&
                                    <Button
                                        icon={<RedoOutlined />}
                                        className="btn btn-danger rounded-4"
                                        shape="round"
                                        onClick={handleClearAllFilters} // Use the new handler
                                    >
                                        Clear Filter
                                    </Button>
                                }
                                <Button
                                    className="primary-btn"
                                    icon={<SearchOutlined />}
                                    shape="round"
                                    type="primary"
                                    onClick={() => setSearchModal(true)}
                                >
                                    Search Filter
                                </Button>

                                {role_id == 3 &&
                                    <>
                                        <Button onClick={() => navigate('/box-history')} style={{ marginLeft: "10px" }} className="btn btn-success rounded-4" >
                                            View Box History
                                        </Button>
                                    </>}
                            </div>


                            {/* Search Filter Modal */}
                            <Modal
                                open={searchModal}
                                onCancel={handleCancel} // Use new cancel handler to reset form
                                okText="Search"
                                // 5. Link the Modal's OK button to the Form submission
                                okButtonProps={{
                                    htmlType: 'submit', // This makes the button trigger the form's onFinish
                                    form: 'searchFilterForm', // Link it to the Form component's ID
                                }}
                                title={
                                    <span>
                                        Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                                        <hr />
                                    </span>
                                }
                                width={600}
                            >
                                {/* 6. Wrap content in Ant Design Form */}
                                <Form
                                    form={searchForm} // Pass the form instance
                                    id="searchFilterForm" // Important: Give the form an ID
                                    onFinish={handleSearch} // This is called when 'Enter' is pressed in an Input or 'Search' is clicked
                                    layout="vertical"
                                    initialValues={{
                                        // Set initial values (e.g., to match external state if applicable, otherwise leave blank)
                                        searchText: '',
                                        searchDate: null,
                                        stage: null,
                                        boxStatusValue: null,
                                    }}
                                >
                                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                        {/* First Line: Spec */}
                                        <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Search by Spec</label>}
                                            name="searchText" // Use 'name' to map to form values
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Input
                                                placeholder="Enter Spec"
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item>

                                        {/* Second Line: Pickup Date */}
                                        <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Pickup Date</label>}
                                            name="searchDate" // Use 'name' for DatePicker
                                            style={{ marginBottom: 0 }}
                                        >
                                            <DatePicker
                                                style={{ width: "100%" }}
                                                placeholder="Select Pickup Date"
                                                format="MM/DD/YYYY"
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item>

                                        {/* Third Line: Filter By Event Stage */}
                                        {/* <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Filter By Event Stage</label>}
                                            name="stage"
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Select
                                                options={eventData}
                                                placeholder="Select Event Stage"
                                                allowClear
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item> */}

                                        {/* Fourth Line: Filter By Status */}
                                        <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Filter By Status</label>}
                                            name="boxStatusValue"
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Select
                                                options={boxStatus}
                                                placeholder="Select Box Status"
                                                allowClear
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item>
                                    </div>
                                </Form>
                            </Modal>
                        </div>
                    </>
                }
            >
                <TableComponent columns={columns} dataSource={tableData} size={"small"} />
            </Card>

        </>
    )
}

export default EventBoxes
